import { Form, Modal, Button, Icon, Input, message } from "antd";
import React, { useContext, useRef } from "react";
import { AuditMarkingContext } from "../../../context";
import * as actiontyes from "../../../reducer/action";
import {
  aditMarkingTaggingAdd,
  aditMarkingTaggingCheckTag,
} from "../../../../../../api/inspiration";
import "./AddTagsModal.less";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
};

function AddTagsModal(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, validateFields } =
    props.form;
  const { state, dispatch } = useContext(AuditMarkingContext);
  const id = useRef(1);
  getFieldDecorator("keys", {
    initialValue: [0],
  });
  // 渲染输入框
  const formItems = (keys) => {
    return keys.map((k, index) => (
      <Form.Item
        {...formItemLayout}
        label={"标签" + (index + 1)}
        required={false}
        key={k}
      >
        {getFieldDecorator(`names[${k}]`, {
          validateTrigger: ["onChange", "onBlur"],
          rules: [
            {
              required: true,
              whitespace: true,
              validator: async (rule, value, callback) => {
                const result = await aditMarkingTaggingCheckTag(value);
                if (value.trim() === "") {
                  callback('请务必输入新标签词')
                  return;
                }
                if (!(result?.error?.code === 0)) {
                  callback("该标签已经存在！");
                }
              },
            },
          ],
          validateTrigger: "onBlur",
        })(
          <Input
            placeholder="请输入新标签"
            style={{ width: "60%", marginRight: 8 }}
          />
        )}
        {keys.length > 1 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => remove(k)}
          />
        ) : null}
      </Form.Item>
    ));
  };
  // 新增输入框
  const add = () => {
    const keys = getFieldValue("keys");
    const nextKeys = keys.concat(id.current++);
    setFieldsValue({
      keys: nextKeys,
    });
  };
  // 删除输入框
  const remove = (k) => {
    // can use data-binding to get
    const keys = getFieldValue("keys");
    // We need at least one passenger
    if (keys.length === 1) {
      return;
    }

    // can use data-binding to set
    setFieldsValue({
      keys: keys.filter((key) => key !== k),
    });
  };

  // 提交
  const handleSubmit = (e) => {
    e.preventDefault();
    validateFields(async (err, values) => {
      if (!err) {
        const { keys, names } = values;
        console.log("Received values of form: ", values);
        const tagList = keys.map((key) => {
          return { word: names[key] };
        });
        console.log("Merged values:", tagList);
        if (tagList.length > 0) {
          const result = await aditMarkingTaggingAdd(tagList);
          if (result?.error?.code === 0) {
            message.success("新增自定义标签成功");
          } else {
            message.error("新增标签失败！错误为：" + result.error.message);
          }
          closeAddNewTagModal();
        } else {
          message.info("请至少输入一个标签！");
        }
      }
    });
  };
  // 关闭模态框
  const closeAddNewTagModal = () => {
    dispatch({
      type: actiontyes.setData,
      data: {
        addNewTagModalVisible: false,
      },
    });
    id.current = 1;
    setFieldsValue({
      keys: [0],
    });
  };
  return (
    <div>
      <Button
        onClick={() => {
          dispatch({
            type: actiontyes.setData,
            data: {
              addNewTagModalVisible: true,
            },
          });
        }}
      >
        新增标签
      </Button>
      <Modal
        visible={state.addNewTagModalVisible}
        destroyOnClose
        title="添加新标签"
        footer={null}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={closeAddNewTagModal}
      >
        <Form {...formItemLayout}>
          {formItems(getFieldValue("keys"))}
          <Form.Item {...formItemLayoutWithOutLabel}>
            <Button type="dashed" onClick={add} style={{ width: "60%" }}>
              <Icon type="plus" /> 新增标签
            </Button>
          </Form.Item>
          <Form.Item {...formItemLayoutWithOutLabel}>
            <div
              style={{
                width: 236,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button type="default" onClick={closeAddNewTagModal}>
                取消
              </Button>
              <Button
                disabled={getFieldValue("keys").length === 0}
                type="primary"
                onClick={handleSubmit}
              >
                提交
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

const Index = Form.create({})(AddTagsModal);
export default Index;
